module.exports = __webpack_public_path__ + "img/imaging.758d73d6.png";